import React__default from 'react';
import { isNamedComponent } from '../../PageLayout/utils.js';
import { validChildren } from './constants.js';
import { VisualElementGroupWrapper, VisualElementWrapper } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function getReversedKey(arr) {
  return arr.map((_, index) => arr.length - index);
}
const VisualElementGroup = ({
  size = 'lg',
  children,
  lastOnTop = false
}) => {
  const renderChildren = [];
  React__default.Children.forEach(children, child => {
    const validName = validChildren.find((_, key) => {
      return isNamedComponent(child, validChildren[key]);
    });
    if (validName) {
      if (React__default.isValidElement(child)) {
        renderChildren.push(React__default.cloneElement(child, {
          size
        }));
      }
    } else {
      console.error('VisualElementGroup only accepts Visual Element components');
    }
  });
  return jsx(VisualElementGroupWrapper, {
    children: renderChildren.map((child, key) => jsx(VisualElementWrapper, {
      size: size,
      zIndex: lastOnTop ? key : getReversedKey(renderChildren)[key],
      children: child
    }, key))
  });
};
VisualElementGroup.displayName = 'VisualElementGroup';

export { VisualElementGroup };
